import {
  Coffee,
  UtensilsCrossed,
  Hotel,
  Bike,
  ShoppingCart,
  Package,
  Store,
  Gift,
  BedDouble,
} from "lucide-react";
import { industries } from "@/data/site";
import { IDS } from "@/constants/testIds";
import Reveal from "@/components/site/Reveal";

const iconMap = {
  Coffee,
  UtensilsCrossed,
  Hotel,
  Bike,
  ShoppingCart,
  Package,
  Store,
  Gift,
  BedDouble,
};

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid={IDS.industriesSection}
      className="relative py-24 sm:py-32 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <Reveal className="lg:col-span-4">
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">
              Industries We Serve
            </span>
            <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold leading-[1.08] tracking-tight text-ink">
              Trusted by teams across{" "}
              <span className="font-serif-accent italic font-medium text-brand">
                nine industries.
              </span>
            </h2>
            <p className="mt-6 text-mist leading-relaxed">
              From boutique coffee brands to national supermarket chains, we
              tailor packaging solutions to your brand and volume.
            </p>
          </Reveal>

          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
            {industries.map((it, i) => {
              const Icon = iconMap[it.icon];
              return (
                <Reveal key={it.name} delay={i * 0.04}>
                  <div className="group bg-white rounded-2xl p-6 border border-line hover:bg-forest hover:border-forest hover:text-white transition-all duration-500 cursor-default hover:-translate-y-1">
                    <Icon
                      className="h-7 w-7 text-brand group-hover:text-sage transition-colors duration-500"
                      strokeWidth={1.6}
                    />
                    <div className="mt-4 font-heading font-medium text-sm sm:text-base leading-snug">
                      {it.name}
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
